import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ClientTradableInvestments } from '../../../Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientTradableInvestmentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, subHiercharyId: string, batchId: number, excludeNonPortfolioAdj: boolean): Promise<ClientTradableInvestments, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Investment/ClientTradableInvestment/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, subHiercharyId: subHiercharyId, batchId: batchId, excludeNonPortfolioAdj: excludeNonPortfolioAdj }

    return AjaxWrapper.get<ClientTradableInvestments, any>(url, data);
  }
}

